import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AddressDataModel, CustomerVM, ErrorMessageModel } from 'src/app/models/customer/customer.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-address-update',
  templateUrl: './customer-address-update.component.html',
  styleUrls: ['./customer-address-update.component.css']
})
export class CustomerAddressUpdateComponent implements OnInit {

  updateCustomerAddress: CustomerVM = new CustomerVM;
  Loader: boolean = false;
  updateCustomerAddressListVm: AddressDataModel = new AddressDataModel();
  customerAddressList: CustomerVM = new CustomerVM();
  customerAddressId: string;
  userSub: Subscription;
  customerId: string;
  selectedActiveValue: boolean;
  errorMessageModel: Array<ErrorMessageModel> = new Array<ErrorMessageModel>();
  errorMessages: ErrorMessageModel = new ErrorMessageModel();

  constructor(private alertify: AlertifyService, private _customerService: CustomerService, private modalService: NgbModal, private route: Router) { }

  ngOnInit() {
    this.userSub = this._customerService.getAddressId.subscribe((customerId) => {
      this.customerId = customerId;
    });
    this.getCustomerAddressById();
  }

  getCustomerAddressById() {
    this.Loader = true;
    this._customerService.GetCustomerAddressById(this.customerId).subscribe((response) => {
      var responseBody = JSON.parse(response._body);
      this.updateCustomerAddressListVm = responseBody.responseData;
      this.updateCustomerAddress.AddressTitle = this.updateCustomerAddressListVm.addressTitle;
      this.updateCustomerAddress.City = this.updateCustomerAddressListVm.city;
      this.updateCustomerAddress.State = this.updateCustomerAddressListVm.state;
      this.updateCustomerAddress.PhoneNumber = this.updateCustomerAddressListVm.phoneNumber;
      this.updateCustomerAddress.ZipCode = this.updateCustomerAddressListVm.zipCode;
      this.updateCustomerAddress.Street = this.updateCustomerAddressListVm.street;
      this.updateCustomerAddress.AddressNote = this.updateCustomerAddressListVm.addressNote;
      this.updateCustomerAddress.Landmark = this.updateCustomerAddressListVm.landmark;
      this.updateCustomerAddress.IsDefault = this.updateCustomerAddressListVm.isDefault;
      this.Loader = false;
    });
  }

  onSubmit() {
    if (this.updateCustomerAddress.AddressTitle == undefined || this.updateCustomerAddress.AddressTitle == null || this.updateCustomerAddress.AddressTitle == "") {
      this.alertify.error("Address Title is required");
      return;
    }
    if (this.updateCustomerAddress.City == undefined || this.updateCustomerAddress.City == null || this.updateCustomerAddress.City == "") {
      this.alertify.error("City Title is required");
      return;
    }
    if (this.updateCustomerAddress.State == undefined || this.updateCustomerAddress.State == null || this.updateCustomerAddress.State == "") {
      this.alertify.error("State Title is required");
      return;
    }
    if (this.updateCustomerAddress.PhoneNumber == undefined || this.updateCustomerAddress.PhoneNumber == null || this.updateCustomerAddress.PhoneNumber == "") {
      this.alertify.error("PhoneNumber Title is required");
      return;
    }
    if (this.updateCustomerAddress.ZipCode == undefined || this.updateCustomerAddress.ZipCode == null || this.updateCustomerAddress.ZipCode == "") {
      this.alertify.error("ZipCode is required");
      return;
    }
    if (this.updateCustomerAddress.Street == undefined || this.updateCustomerAddress.Street == null || this.updateCustomerAddress.Street == "") {
      this.alertify.error("Street is required");
      return;
    }
    // if (this.updateCustomerAddress.AddressNote == undefined || this.updateCustomerAddress.AddressNote == null || this.updateCustomerAddress.AddressNote == "") {
    //   this.alertify.error("Street is required");
    //   return;
    // }
    // if (this.updateCustomerAddress.Landmark == undefined || this.updateCustomerAddress.Landmark == null || this.updateCustomerAddress.Landmark == "") {
    //   this.alertify.error("Street is required");
    //   return;
    // }
    this.errorMessageModel = [];
    this.Loader = true;
    this.updateCustomerAddress.Id = +this.customerId;
    this._customerService.CustomerUpdateAddress(this.updateCustomerAddress)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.updateCustomerAddress = responseBody.responseData;
          this.alertify.success(responseBody.responseMessage);
          this.Loader = false;
          this.modalService.dismissAll();
        } else {
          for(var i = 0; i < responseBody.responseData.messages.length; i++) {
            this.errorMessages = responseBody.responseData.messages[i];
            var messagesItem = new ErrorMessageModel();
            if (this.errorMessages) {
              messagesItem = this.errorMessages;
              this.errorMessageModel.push(messagesItem);
            }
            this.Loader = false;
        }
        }
      });
  }
  onCancel() {
    this.modalService.dismissAll();
  }
  selectActive(selectedValue) {
    this.selectedActiveValue = selectedValue;
  }
}
